import { utility } from "../../Utility";
import { LocalStorage, Storage } from "../../Utility/Services"

export const responseHandler = async (res) => {

    let { status } = res;
    res = await res.json()

    if (status === 200)
        return res

    if ([403, 401].includes(status)) {
        Storage.clear()
        utility.navigate('/')
    }

    throw new Error(res.message, { cause: res.status })

}